import { useGA4Events } from '../../hooks'
import { useModalContext } from './context'
import { Steps } from './enums'
import { FLOW_STEPS } from './flow-steps'

export const StepRenderer = (props: {
  currentStep: Steps
  onClose: () => void
  stepsCallback?: (isValidatedSuccess: boolean) => void
}) => {
  const { onClose, currentStep, stepsCallback } = props
  const { sharedData, eventData, viewer, texts } = useModalContext()

  const gA4EventHandlers = useGA4Events()

  const renderStep = FLOW_STEPS[currentStep]
  return renderStep({
    onClose,
    sharedData,
    eventData,
    stepsCallback,
    viewer,
    gA4EventHandlers,
    texts,
  })
}
